import React, { useEffect, useState } from "react";
import { Nav } from "react-bootstrap";
import {
  AiOutlineMinus as CloseIcon,
  AiOutlinePlus as OpenIcon
} from "react-icons/ai";
import {
  FaBars,
  FaDollarSign,
  FaFileInvoiceDollar,
  FaFingerprint,
  FaThumbsUp,
  FaWindowClose
} from "react-icons/fa";
import { Link } from "react-router-dom";
import Icons from "../components/Icons";
import logo from "../images/logo.png";
import { Constants } from "../libs/Constants";
import { CustomIcon } from "./CustomSvgIcons";
import "./SideBar.scss";
export default class Sidebar extends React.Component {
  constructor(props) {
    super(props);
    this.handleOut = this.handleOut.bind(this);
    this.buildPerimissionBasedSidebar = this.buildPerimissionBasedSidebar.bind(
      this
    );

    this.state = {
      sidebarIsOpen: false,
    };
  }
  async handleOut() {
    this.props.handleLogout();
  }

  buildPerimissionBasedSidebar() {
    let taablAdminDropDown = null;
    let adminDropDown = null;
    if (
      this.props.userObj &&
      this.props.userObj.permission !== Constants.PermissionLevel.UNABLE &&
      this.props.userObj.permission >= Constants.PermissionLevel.ADMIN
    ) {
      adminDropDown = (
        <>
          <Nav.Link
            as={Link}
            to="/expenseDashboard"
            className={`${
              this.state.sidebarIsOpen
                ? "d-block d-md-block d-lg-block"
                : "d-none d-md-block d-lg-block"
              }`}
          >
            <CustomIcon icon="expenses"></CustomIcon>
            <span>Expenses</span>
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/exceptionreport"
            className={`${
              this.state.sidebarIsOpen
                ? "d-block d-md-block d-lg-block"
                : "d-none d-md-block d-lg-block"
              }`}
          >
            <CustomIcon icon="exception"></CustomIcon>
            <span>Exception Report</span>
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/settings/list/TaablAdmin/User"
            className={`${
              this.state.sidebarIsOpen
                ? "d-block d-md-block d-lg-block"
                : "d-none d-md-block d-lg-block"
              }`}
          >
            <CustomIcon icon="employees"></CustomIcon>
            <span>People</span>
          </Nav.Link>
          <Nav.Link
            as={Link}
            to="/settings/list/TaablAdmin/offeringPeriod"
            className={`${
              this.state.sidebarIsOpen
                ? "d-block d-md-block d-lg-block"
                : "d-none d-md-block d-lg-block"
              }`}
          >
            <CustomIcon icon="periods"></CustomIcon>
            <span>Offering Period</span>
          </Nav.Link>
          <Submenu
            title="Company"
            icon="companysidebar"
            sidebarIsOpen={this.state.sidebarIsOpen}
          >
            <div className="subitem" aria-labelledby="navbarDropdown">
              <ul>
                <li>
                  <Nav.Link as={Link} className="nav-link" to="/planDetails">
                    <CustomIcon icon="espp"></CustomIcon>
                    <span>ESPP Details</span>
                  </Nav.Link>
                </li>

                <li>
                  <Nav.Link as={Link} className="nav-link " to="/blackScholes">
                    <CustomIcon icon="blackscholes"></CustomIcon>
                    <span>Black Scholes</span>
                  </Nav.Link>
                </li>
                <li>
                  <Nav.Link
                    as={Link}
                    className="nav-link "
                    to="/settings/list/period"
                  >
                    <CustomIcon icon="periods"></CustomIcon>
                    <span>Periods</span>
                  </Nav.Link>
                </li>
                <li>
                  <Nav.Link as={Link} className="nav-link " to="/imports">
                    <CustomIcon icon="import"></CustomIcon>
                    <span>Documents</span>
                  </Nav.Link>
                </li>
                <li>
                  <Nav.Link
                    as={Link}
                    className="nav-link "
                    to={`/editObj/${JSON.stringify({
                      type: "Company",
                      id: this.props.activeCompany.id,
                    })}`}
                  >
                    <Icons
                      icon="edit"
                      className="edit sidebar-icon"
                      aria-placeholder="Edit"
                    ></Icons>
                    <span>Edit Company</span>
                  </Nav.Link>
                </li>
                <li>
                  <Link className="nav-link " to="/periodendreport">
                    <CustomIcon icon="periodendreport"></CustomIcon>
                    <span>Summary Report</span>
                  </Link>
                </li>
              </ul>
            </div>
          </Submenu>
        </>
      );
    }
    if (
      this.props.userObj &&
      this.props.userObj.permission !== Constants.PermissionLevel.UNABLE &&
      this.props.userObj.permission >= Constants.PermissionLevel.TAABL_ADMIN
    ) {
      taablAdminDropDown = (
        <>
          <Submenu
            title="Taabl Admin"
            icon="taabladmin"
            sidebarIsOpen={this.state.sidebarIsOpen}
          >
            <div className="subitem" aria-labelledby="navbarDropdown">
              <ul>
                <li>
                  <Link className="nav-link " to="/settings/list/Company">
                    <CustomIcon icon="companies"></CustomIcon>
                    <span>Companies</span>
                  </Link>
                </li>
                <li>
                  <Link className="nav-link " to="/reports">
                    <CustomIcon icon="rerun"></CustomIcon>
                    <span>Rerun Reports</span>
                  </Link>
                </li>
                <li>
                  <Link className="nav-link " to="/transactions">
                    <FaDollarSign></FaDollarSign>
                    <span>Transfer</span>
                  </Link>
                </li>
                <li>
                  <Link className="nav-link " to="/signupevents">
                    <FaFingerprint></FaFingerprint>
                    <span>Signup Events</span>
                  </Link>
                </li>
                <li>
                  <Link className="nav-link " to="/approvals">
                    <FaThumbsUp></FaThumbsUp>
                    <span>Approvals</span>
                  </Link>
                </li>
                <li>
                  <Link className="nav-link " to="/repayment">
                    <FaFileInvoiceDollar></FaFileInvoiceDollar>
                    <span>Repayment</span>
                  </Link>
                </li>
              </ul>
            </div>
          </Submenu>
        </>
      );
    }
    return (
      <>
        {adminDropDown}
        {taablAdminDropDown}
      </>
    );
  }

  render() {
    const { location } = this.props;
    return (
      <Nav
        defaultActiveKey="/"
        activeKey={location?.pathname}
        className={`flex-column sidebar ${this.props.expand ? "active" : ""} ${
          this.state.sidebarIsOpen === true ? "sidebarOpen" : ""
          }`}
        onMouseLeave={() => this.setState({ sidebarIsOpen: false })}
      // onMouseEnter={() => this.setState({ sidebarIsOpen: true })}
      >
        <div className="scrollable-sidebar flex-column">
          <div className="d-flex d-inline-block align-top align-items-center">
            <div className="d-block d-md-none d-lg-none pt-3 pb-3 ps-3">
              <FaBars
                className={`${this.state.sidebarIsOpen ? "d-none" : "d-block"}`}
                onClick={() => this.setState({ sidebarIsOpen: true })}
              />
              <FaWindowClose
                className={`${this.state.sidebarIsOpen ? "d-block" : "d-none"}`}
                onClick={() => {
                  this.setState({ sidebarIsOpen: false });
                }}
              />
            </div>
            <img src={logo} className="brand" />
          </div>
          <Nav.Link
            className={`${
              this.state.sidebarIsOpen
                ? "d-block d-md-block d-lg-block"
                : "d-none d-md-block d-lg-block"
              }`}
          ></Nav.Link>
          <Nav.Link
            as={Link}
            to="/"
            className={`${
              this.state.sidebarIsOpen
                ? "d-block d-md-block d-lg-block"
                : "d-none d-md-block d-lg-block"
              }`}
          >
            <CustomIcon icon="dashboard"></CustomIcon>
            <span>Dashboard</span>
          </Nav.Link>
          {this.buildPerimissionBasedSidebar()}
          <span
            className={`${
              this.state.sidebarIsOpen
                ? "d-block d-md-block d-lg-block bottom-menu"
                : "d-none d-md-block d-lg-block bottom-menu"
              }`}
          >
            <Nav.Link as={Link} to="/settings" className="bottom">
              <CustomIcon icon="settings"></CustomIcon>
              <span>Settings</span>
            </Nav.Link>
            <Nav.Link onClick={this.handleOut}>
              <CustomIcon icon="logout"></CustomIcon>
              <span>Logout</span>
            </Nav.Link>
          </span>
        </div>
      </Nav>
    );
  }
}

const Submenu = (props) => {
  const [openMenu, setOpenMenu] = useState(false);

  useEffect(() => {
    if (!props.sidebarIsOpen) {
      setOpenMenu(false);
    }
  }, [props.sidebarIsOpen]);

  return (
    <Nav.Item
      className={`submenu ${openMenu ? "submenu-active" : null}`}
      onClick={() => setOpenMenu(!openMenu)}
    >
      <a
        className={`nav-link ${
          props.sidebarIsOpen
            ? "d-block d-md-block d-lg-block"
            : "d-none d-md-block d-lg-block"
          }`}
      >
        <CustomIcon icon={props.icon}></CustomIcon>
        <span>{props.title}</span>
        <span className="pull-right">
          {openMenu ? <CloseIcon /> : <OpenIcon />}
        </span>
      </a>
      {props.children}
    </Nav.Item>
  );
};
